module.exports = __webpack_public_path__ + "assets/img/Inter-Thin.svg?e02872cd9c75e44eb368b12c1fad251c";